import React, {useEffect, useState} from 'react';
import s from './styles.module.css'
import classNames from "classnames";
import {useStore} from "../../../../hooks/useStore";
import AlertDialog from "../../../../components/dialog_modal";
import {FormControl, InputLabel, MenuItem, Select, Tooltip} from "@mui/material";
import GroupsIcon from '@mui/icons-material/Groups';
import api from "../../../../api/api";

const CommandItem = ({
                         isReferee,
                         rank,
                         competition_draw,
                         poins_behind,
                         command_name,
                         activeCommand,
                         index,
                         competition_application_name,
                         total_difficulty_result,
                         selectedCommand,
                         element_result,
                         impression_result,
                         id,
                         isNotStarted,
                         isDisqualified,
                         handlerSelectCommand,
                         total_result,
                         is_processing,
                         doubleStartJudging
                     }) => {
    const store = useStore()
    const selectedBox = selectedCommand === id ? s.selected : ''
    const [openModal, setOpenModal] = useState(false)
    const [select, setSelect] = useState('');

    useEffect(() => {
        console.log(isDisqualified + " " + isNotStarted)
        if (isNotStarted === 0 && isDisqualified === 0) {
            setSelect('---');
        } else if (isNotStarted === 1) {
            setSelect('DNS');
        } else {
            setSelect('DSQ');
        }
    }, [isNotStarted, isDisqualified]);

    const handleChange = async (event) => {
        setSelect(event.target.value);
        let body = {
            competition_application_discipline_id: id,
            is_not_started: null,
            is_disqualified: null
        }
        if (event.target.value === '---') {
            body.is_not_started = 0;
            body.is_disqualified = 0;
        } else if (event.target.value === 'DNS') {
            body.is_not_started = 1;
            body.is_disqualified = 0;
        } else if (event.target.value === 'DSQ') {
            body.is_not_started = 0;
            body.is_disqualified = 1;
        }

        if (body.is_not_started !== null && body.is_disqualified !== null) {
            const res = await api().patch('/change-not-started-or-disqualified', body);
            console.log(res);
        }
    };

    const handlerConfirm = async () => {
        await doubleStartJudging(id)
        setOpenModal(false)
    }
    // doubleStartJudging
    return (
        <div className={s.item}
             onClick={() => {
                 handlerSelectCommand(id)
             }}>
            <AlertDialog title={store.judging?.check?.msg} status={store.judging?.check?.status}
                         actions={store.judging?.check?.answers} open={openModal} setOpen={setOpenModal}
                         handlerConfirm={async (id) => {
                             if (store.judging?.check?.status === 'question') {
                                 const res = await store.judging.confirmConfirm(id, activeCommand)
                             }
                             handlerConfirm()
                         }}/>

            <div className={s.number_command_name}>
                <div onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                }}
                     className={classNames(s.number, is_processing && s.active_command, (select === 'DNS' || select === 'DSQ') && s.disable_command)}
                     onDoubleClick={(e) => {
                         if (select === 'DNS' || select === 'DSQ') {
                             return;
                         }
                         e.preventDefault()
                         e.stopPropagation()
                         if (store.judging.status.status !== 'start' || isReferee) return
                         store.judging.checkJudging(setOpenModal, activeCommand)
                     }}>{competition_draw}</div>

                <div className={classNames(s.command_name, selectedBox)}>{competition_application_name || '---'}</div>

                <Tooltip title={command_name}>
                    <div className={s.team_icon}>
                        <GroupsIcon/>
                    </div>
                </Tooltip>
            </div>

            <div className={classNames(s.total_name, selectedBox)}>{total_difficulty_result || '---'}</div>
            <div className={classNames(s.elements_name, selectedBox)}>{element_result || '---'}</div>
            <div className={classNames(s.artistik_name, selectedBox)}>{impression_result || '---'}</div>
            <div className={classNames(s.point_name, selectedBox)}>{total_result || '---'}</div>
            <div className={classNames(s.total_name, selectedBox)}>{poins_behind || '---'}</div>
            <div className={classNames(s.rank_name, selectedBox)}>{rank || '---'}</div>
            <FormControl sx={{m: 1, minWidth: 86}}>
                <Select
                    labelId="select-label"
                    value={select}
                    onChange={handleChange}
                    inputProps={{'aria-label': 'Выбор опции'}}
                    sx={{
                        marginLeft: '20px',
                        height: '30px',
                        width: '86px',
                        backgroundColor: '#fff',
                        fontSize: '13px'
                    }}
                >
                    <MenuItem value="---" sx={{fontSize: '13px'}}>---</MenuItem>
                    <MenuItem value="DNS" sx={{fontSize: '13px'}}>DNS</MenuItem>
                    <MenuItem value="DSQ" sx={{fontSize: '13px'}}>DSQ</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
};

export default CommandItem;
